import { gql } from '@apollo/client'
import * as React from 'react'
import { uploadToTemp } from '../../../models/Storage'
import { withMutation, MutateProps } from '@apollo/client/react/hoc'
import { compose } from 'recompose'
import { List, Input } from '../..'
import { LinearProgress } from '@material-ui/core'
import { Button } from '@material-ui/core'
import ResourceDialog from './ResourceDialog'
import { acceptExt, uploadFileSize } from '../../../contracts'
import { useTranslation } from 'i18n'

type Props = {
  value: any
  type: string
  onClose: Function
  onChange: Function
  sendMessage: Function
} & MutateProps

const Component: React.FC<Props> = ({
  type,
  onChange,
  mutate,
  onClose,
  sendMessage,
  value,
}) => {
  const { t } = useTranslation('components')
  const label = t('Input.Resource.' + type) + t('Input.Resource.file')
  const [resource, setResource] = React.useState(value || null)
  const [completed, setCompleted] = React.useState(0)
  const [dialogOpen, setDialogOpen] = React.useState(false)

  const onDrop = acceptedFiles => {
    if (!acceptedFiles.length) return
    const file = acceptedFiles[0]

    // アーティストのリソースにアップロードする
    const task = uploadToTemp(file)
    setDialogOpen(false)

    task.on(
      'state_changed',
      snapshot => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        setCompleted(Math.min(progress, 100))
      },
      () => {},
      // completed
      () => {
        // resourceに登録する
        const filePath = task.snapshot.ref.fullPath
        mutate({ variables: { filePath, name: file.name } })
          .then(({ data: { createResource: resource } }: any) => {
            setResource(resource)
            onChange(resource)
            setCompleted(0)
          })
          .catch(error => {
            setCompleted(0)
            sendMessage(t('Input.Resource.uploadError'), 'error')
          })
      }
    )
  }

  return (
    <>
      <Input.Label style={{ margin: '0 0 20px 0' }}>{label}</Input.Label>
      {resource ? (
        <List.Resource
          resource={resource}
          onClose={e => {
            onClose(e)
            setResource(null)
          }}
        />
      ) : (
        <div style={{ minHeight: 80 }}>
          {completed === 0 ? (
            <>
              <Input.Upload
                onDrop={onDrop}
                accept={acceptExt[type]}
                maxSize={uploadFileSize[type]}
              />
              <div style={{ textAlign: 'right', padding: '3px 0' }}>
                <Button onClick={() => setDialogOpen(true)}>
                  {t('Input.Resource.selectFromSavedFiles')}
                </Button>
              </div>
              <ResourceDialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                type={type}
                onComplete={resource => {
                  setDialogOpen(false)
                  setResource(resource)
                  onChange(resource)
                }}
              />
            </>
          ) : (
            <LinearProgress variant="determinate" value={completed} />
          )}
        </div>
      )}
    </>
  )
}

const CREATE_RESOURCE = gql`
  mutation($filePath: String!, $name: String!) {
    createResource(filePath: $filePath, name: $name) {
      ... on Resource {
        id
        name
        type
      }
    }
  }
`

const ComposedComponent = compose(withMutation(CREATE_RESOURCE))(Component)

export default ComposedComponent
